module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABEAAAAOCAYAAADJ7fe0AAAAgUlEQVQokWO0t/f8z0AhYHnnto2REgMuVTEwMFHqCgYGKhnCgk9SaJeXAQMDw3QGBobMd27bLpDsEqFdXt4MzOyHfyqGWTAwsx8W2uXlQ5IhQru8chgYGDYy/P3Jw35/FQPD3588DAwMG6DiGIBRtxV/DAvt8vqPLwYHV+yMGoIJAMvoIReaD/+BAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/components/report/design/assets/07c.png
// module id = GFAZ
// module chunks = 64